import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { createEFPic } from '@/utils/useEFPic';

import { useLang } from '@/i18n';
import { powerStreamImgMap } from '@/constants/powerStream';

const { EFPic } = createEFPic('/media/power-stream/teaser/pc/');

const TextComponent = ({ className, title, desc }: any) => {
    return (
        <div className={`text-comp ${className}`}>
            <div className="rel-title">
                <p className="text-title">{title}</p>
            </div>
            <p className="text-line"></p>
            <div className="rel-desc">
                <p className="text-desc">{desc}</p>
            </div>
        </div>
    );
};

export default function SectionC() {
    const { t } = useLang('powerstream.detail.sectionC');
    const { locale } = useRouter();

    const [showAni, setShowAni] = useState(false);
    const powerStreamImg = powerStreamImgMap[locale as keyof typeof powerStreamImgMap] || powerStreamImgMap.eu;

    const data = [
        { title: t('title1'), desc: t('desc1'), className: 'solar-panel' },
        { title: t('title2'), desc: t('desc2'), className: 'micro-inverter' },
        { title: t('title3'), desc: t('desc3'), className: 'power-station' },
        { title: t('title4'), desc: t('desc4'), className: 'smart-plug' },
    ];

    useEffect(() => {
        AniContainer.create({
            triggerElement: '.c-section',
            offset: '40%',
            duration: 0,
            triggerHook: 1,
            onEnter: () => {
                if (!showAni) {
                    setShowAni(true);
                }
            },
        });
    }, []);

    return (
        <div className={styles.sectionC}>
            <div className="c-section">
                <div className="bg-box">
                    <EFPic className="bg-img" name={powerStreamImg} />
                    {data.map((item: Record<string, string>, index) => (
                        <TextComponent className={`${item.className} ${showAni ? 'show-ani' : ''}`} key={index} title={item.title} desc={item.desc} />
                    ))}
                </div>
            </div>
        </div>
    );
}
